// extracted by css-extract-rspack-plugin
export default {"root":"MaskActions_root__BJxvD","buttons":"MaskActions_buttons__f+Mt0"};